export const IS_CYPRESS = 'Cypress' in window;
